import React, { ReactElement } from 'react';
import { useAuthentication } from '../../hooks/useAuthentication';
import { useEventHandling } from '../../hooks/useEventHandling';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import env from '../../environments/environment';

const { msalConfig } = env;

const AuthEventProvider: React.FC<{
  children: ReactElement;
}> = ({ children }) => {
  const handlingRedirect = useAuthentication();
  useEventHandling();

  if (handlingRedirect) {
    return null;
  }

  return children;
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const WithAuth: React.FC<{ children: React.ReactElement }> = ({
  children,
}) => {
  return (
    <MsalProvider instance={msalInstance}>
      <AuthEventProvider>{children}</AuthEventProvider>
    </MsalProvider>
  );
};
